interface Dictionary<T> {
  [index: string]: T;
}

export function at<T>(obj: Dictionary<T>, keys: string[]): T[] {
  return keys.map((key) => obj[key]);
}
